
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/erpcige/cigecpe",
      function () {
        return require("private-next-pages/erpcige/cigecpe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/erpcige/cigecpe"])
      });
    }
  